<template>
  <div class="slider" :class="{ leftTooltip, rightTooltip }">
    <div class="slider__title">{{ title }}</div>
    <div id="slider" ref="slider" />
    <input
      class="slider__input"
      ref="inputSlider"
      type="text"
      :class="{ leftTooltipInput: leftTooltip, rightTooltipInput: rightTooltip }"
      :value="valueInputSlider"
      :style="`width: ${widthInputSlider}`"
      v-mask="masksInputSlider"
      @change="onChangeInputSlider"
      @keyup="onKeyupInputSlider"
    />
    <div class="slider__range">
      <span>{{ minRange }}</span>
      <span>{{ maxRange }}</span>
    </div>
  </div>
</template>

<script>
import wnumb from "wnumb";
import noUiSlider from "nouislider";
import "nouislider/dist/nouislider.css";
import { mask } from "vue-the-mask";

export default {
  name: "Slider",
  props: {
    title: {
      type: String,
      default: "",
    },
    masksInputSlider: {
      type: Array,
      default() {
        return [];
      },
    },
    sliderValues: {
      type: Object,
      required: true,
    },
    currencyDeposit: {
      type: Number,
      default: 1,
    },
    amount: {
      type: Number,
      required: true,
    },
    period: {
      type: Boolean,
    },
    purchases: {
      type: Boolean,
    },
  },
  directives: {
    mask,
  },
  data() {
    return {
      valueInputSlider: null,
      leftTooltip: false,
      rightTooltip: false,
      widthInputSlider: null,
      amountDeposit: 0,
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    },
    minRange() {
      if (this.period) {
        return this.sliderValues.min;
      }
      return `${this.sliderValues.min.toLocaleString("ru-RU")} ${this.sliderValues.symbol}`;
    },
    maxRange() {
      if (this.period) {
        return this.sliderValues.max;
      }
      return `${this.sliderValues.max.toLocaleString("ru-RU")} ${this.sliderValues.symbol}`;
    },
  },
  updated() {
    this.$nextTick(function () {
      this.updateStylesInputSlider();
    });
  },
  mounted() {
    this.amountDeposit = this.amount;
    noUiSlider.create(this.$refs.slider, {
      format: {
        to: function (value) {
          return Math.round(value);
        },
        from: function (value) {
          return parseInt(value);
        },
      },
      tooltips: [
        wnumb({
          decimals: 0,
          thousand: " ",
          suffix: this.sliderValues.symbol ? ` ${this.sliderValues.symbol}` : "",
        }),
      ],
      start: [this.sliderValues.initialValue],
      connect: [true, false],
      step: this.sliderValues.step,
      range: this.sliderValues.range,
      keyboardSupport: false,
    });
    this.$refs.slider.noUiSlider.on("update", (arr, i) => {
      this.amountDeposit = arr[i];
      this.valueInputSlider = this.encodeFormatMoney(this.amountDeposit);
      this.adaptiveSlider();
      this.updateStylesInputSlider();
    });
  },
  watch: {
    currencyDeposit() {
      this.updateOptionsSlider({
        start: [this.amountDeposit],
        range: this.sliderValues.range,
        tooltips: [
          wnumb({
            decimals: 0,
            thousand: " ",
            suffix: " " + this.sliderValues.symbol,
          }),
        ],
      });
      this.updateStylesInputSlider();
    },
    amount(val) {
      this.amountDeposit = val;
      if (this.purchases) {
        this.updateOptionsSlider({
          start: [this.amountDeposit],
          range: this.sliderValues.range,
          tooltips: [
            wnumb({
              decimals: 0,
              thousand: " ",
              suffix: " " + this.sliderValues.symbol,
            }),
          ],
        });
        this.updateStylesInputSlider();
      }
    },
    amountDeposit() {
      this.updateAmount(this.amountDeposit);
    },
  },
  methods: {
    decodeFormatMoney(value) {
      const moneyFormat = wnumb({
        decimals: 0,
        thousand: " ",
        suffix: " " + this.sliderValues.symbol,
      });
      return moneyFormat.from(value);
    },
    encodeFormatMoney(value) {
      const moneyFormat = wnumb({
        decimals: 0,
        thousand: " ",
        suffix: " " + this.sliderValues.symbol,
      });
      return moneyFormat.to(value);
    },
    onChangeInputSlider(e) {
      const value = e.target.value;
      this.$refs.slider.noUiSlider.set(this.decodeFormatMoney(value) || 0);
      this.valueInputSlider = this.$refs.slider.noUiSlider.get();
      this.updateStylesInputSlider();
    },
    onKeyupInputSlider(e) {
      let widthWord = 12;
      if (this.isMobile) {
        widthWord = 8;
      }
      if (e.target.value.length > this.encodeFormatMoney(this.amountDeposit).length) {
        e.target.style.width = `${e.target.value.length * widthWord}px`;
      }
    },
    updateStylesInputSlider() {
      const tooltipSlider = this.$refs.slider.querySelector(".noUi-tooltip");
      this.widthInputSlider = `${tooltipSlider.clientWidth}px`;
      const handlerSlider = this.$refs.slider.querySelector(".noUi-handle");
      handlerSlider.appendChild(this.$refs.inputSlider);
    },
    adaptiveSlider() {
      const onePercent = this.sliderValues.max / 100;
      let percentLeft = onePercent * 50;
      let percentRight = onePercent * 0.85;
      if (this.amountDeposit > percentLeft) {
        this.leftTooltip = false;
        this.rightTooltip = true;
      } else if (this.amountDeposit < percentRight) {
        this.rightTooltip = false;
        this.leftTooltip = true;
      } else {
        this.leftTooltip = false;
        this.rightTooltip = false;
      }
    },
    updateOptionsSlider(options) {
      this.$refs.slider.noUiSlider.updateOptions(options);
    },
    updateAmount(value) {
      this.$emit("change-deposit", value);
    },
  },
};
</script>

<style scoped lang="scss">
.slider {
  position: relative;
  flex: 1;

  &__title {
    font-weight: 500;
    font-size: 24px;
    line-height: 32px;

    @media (max-width: 768px) {
      margin-bottom: 16px;
      font-size: 16px;
      line-height: 24px;
    }
  }

  &__input {
    position: absolute;
    min-width: 80px;
    left: 100%;
    bottom: 120%;
    border: none;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    background: transparent;
    transform: translate(-50%, 0);

    &:focus {
      outline: none;
    }
    @media (min-width: 768px) {
      min-width: 120px;
      text-align: center;
      bottom: 145%;
      font-size: 24px;
      font-weight: 500;
      line-height: 32px;
    }
  }

  &__range {
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    width: 100%;

    span {
      font-size: 14px;
      font-weight: 500;
      line-height: 16px;
      color: var(--gray);
    }
  }
}

::v-deep {
  .noUi-handle {
    top: -8px;
    border: 3px solid var(--main-bg-color);
    border-radius: 50%;
    width: 24px;
    height: 24px;
    box-shadow: none;
    background-color: var(--button-bg-active);
    cursor: pointer;

    &::before,
    &::after {
      display: none;
    }
  }

  .noUi-target {
    margin-top: 44px;
    margin-bottom: 28px;
    border: none;
    border-radius: 33px;
    height: 8px;
    box-shadow: none;
    background: var(--light-gray);

    @media (min-width: 768px) {
      margin-top: 66px;
    }
  }

  .noUi-connect {
    background-color: var(--button-bg-active);
  }

  .noUi-tooltip {
    border: none;
    padding: 0;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    background: transparent;
    opacity: 0;

    @media (min-width: 768px) {
      bottom: 145%;
      font-weight: 400;
      font-size: 24px;
      line-height: 32px;
    }
  }
}

.leftTooltip::v-deep .noUi-tooltip,
.leftTooltipInput {
  transform: translateX(-15%);
}

.rightTooltip::v-deep .noUi-tooltip,
.rightTooltipInput {
  transform: translateX(-100%);
}
</style>
